import React from 'react';
import Markdown from '../Markdown';
import ReadMore from '../ReadMore';
import styled from 'styled-components/macro';
import generateId from '../../utils/generateId';

const Container = styled.div`
  padding: 0 0 0.8em 0;
  p {
    ${({ fontSize }) => fontSize && 'font-size: ' + fontSize + 'px;'}
  }

  ${({ $additionalCSS }) => $additionalCSS}
`;

const Description = ({
  content = '',
  maxChar = 500,
  fontSize,
  additionalCSS = '',
  id = generateId()
}) => {
  return (
    <Container
      role="field-description"
      data-testid="enduserform-description"
      fontSize={fontSize}
      $additionalCSS={additionalCSS}
      data-id={id}
      data-type="description"
    >
      <ReadMore
        needsMore={
          content.replace(/\[([^\]]+)\]\([^\)]+\)/g, '$1').length > maxChar
        }
      >
        <Markdown content={content} />
      </ReadMore>
    </Container>
  );
};

export default Description;
